import { render, staticRenderFns } from "./CreateRace.vue?vue&type=template&id=31ac4a6d&scoped=true&"
import script from "./CreateRace.vue?vue&type=script&lang=js&"
export * from "./CreateRace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac4a6d",
  null
  
)

export default component.exports